import { getActionBaseProvider } from "../../../../Application/actions/actionsBuilder";
import { commonActionTypes } from "../actionTypes/commonAssessmentActionTypes";

export const discardAction = getActionBaseProvider(commonActionTypes.discard);
